<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          お使いのDNSサーバーはSPFレコードを使用しています。
        </p>
        <p v-else>
          お使いのDNSサーバは、SPFレコードを使用していません。<br />SPF（送信者ポリシーフレームワーク）は、管理者がドメインネームシステム（DNS）内の特定のSPFレコードやTXTレコードを作成することにより、特定のドメインからメールを送信することが許可されているホストを指定することができます。
        </p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          SPFレコードは、ドメイン名サービス（DNS）レコードの一種で、メールシステムがメッセージの送信者が正当なソースから来ているかどうかを確認し、ソースが正当でない場合はメールを拒否できます。<br />SPFレコードの追加は、DNSゾーンにCNAME、MX、またはAレコードを追加するのと同じくらい簡単です。詳細については、こちらをご覧ください。<br />ドメインのSPFレコードを作成する前に、ドメインのDNSゾーンにアクセスし、ドメインで使用される可能性のあるメールサーバーを把握し、承認されていないメールの処理方法を計画することが重要です。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
